import moment from 'moment';

const DateFormat = 'YYYY-MM-DD HH:mm:ss';

export type FilterByDateRange = {
    displayName: string;
    value: DateRange;
    from?: string;
    to?: string;
};

export type DateRange = 'all' | 'lastSevenDays' | 'lastThirtyDays';

export type Category = {
    displayName: string;
    id: number;
};

export type NotificationRequestFilterOptions = { dateRangeData?: FilterByDateRange; categories?: Category[] } | null;

export const FiltersByDateRange: FilterByDateRange[] = [
    {
        displayName: 'dashboard.all',
        value: 'all',
        from: moment().startOf('days').format(DateFormat),
        to: moment().endOf('days').format(DateFormat),
    },
    {
        displayName: 'dashboard.lastSevenDays',
        value: 'lastSevenDays',
        from: moment().subtract(7, 'days').startOf('days').format(DateFormat),
        to: moment().endOf('days').format(DateFormat),
    },
    {
        displayName: 'dashboard.lastThirtyDays',
        value: 'lastThirtyDays',
        from: moment().subtract(30, 'days').startOf('days').format(DateFormat),
        to: moment().endOf('days').format(DateFormat),
    },
];
